import { Component, Input, TemplateRef } from '@angular/core';
import { DynamicFieldModel } from '../../../dynamic-form';
import { FieldType } from '@ps-gui/shared-utils';
import {
  DynamicFormCheckboxComponent,
  DynamicFormDatepickerComponent,
  DynamicFormDropdownComponent,
  DynamicFormRadioComponent,
  DynamicFormSwitchComponent,
  DynamicFormTextareComponent,
  DynamicFormTextinputComponent,
} from './types';

@Component({
  selector: 'shared-ui-dynamic-form-field',
  imports: [
    DynamicFormDropdownComponent,
    DynamicFormTextinputComponent,
    DynamicFormDatepickerComponent,
    DynamicFormSwitchComponent,
    DynamicFormRadioComponent,
    DynamicFormCheckboxComponent,
    DynamicFormTextareComponent,
  ],
  template: `
    @if (fieldModel.type === FieldType.SWITCH) {
      <shared-ui-dynamic-form-switch [fieldModel]="fieldModel" [template]="switchTemplate" />
    } @else if (fieldModel.type === FieldType.DROPDOWN) {
      <shared-ui-dynamic-form-dropdown [fieldModel]="fieldModel" [template]="dropdownTemplate" />
    } @else if (fieldModel.type === FieldType.RADIO) {
      <shared-ui-dynamic-form-radio [fieldModel]="fieldModel" [template]="radioTemplate" />
    } @else if (fieldModel.type === FieldType.CHECKBOX) {
      <shared-ui-dynamic-form-checkbox [fieldModel]="fieldModel" [template]="checkboxTemplate" />
    } @else if (fieldModel.type === FieldType.DATE) {
      <shared-ui-dynamic-form-datepicker
        [fieldModel]="fieldModel"
        [template]="datepickerTemplate" />
    } @else if (fieldModel.type === FieldType.TEXTAREA) {
      <shared-ui-dynamic-form-textarea [fieldModel]="fieldModel" [template]="textareaTemplate" />
    } @else {
      <shared-ui-dynamic-form-textinput [fieldModel]="fieldModel" [template]="textinputTemplate" />
    }
  `,
  styles: ``,
})
export class DynamicFormFieldComponent {
  @Input({ required: true }) fieldModel!: DynamicFieldModel;
  @Input() checkboxTemplate?: TemplateRef<unknown>;
  @Input() datepickerTemplate?: TemplateRef<unknown>;
  @Input() dropdownTemplate?: TemplateRef<unknown>;
  @Input() switchTemplate?: TemplateRef<unknown>;
  @Input() textinputTemplate?: TemplateRef<unknown>;
  @Input() radioTemplate?: TemplateRef<unknown>;
  @Input() textareaTemplate?: TemplateRef<unknown>;
  protected readonly FieldType = FieldType;
}
